import React from 'react';
import { m } from 'framer-motion';
import { SectionTag } from '../ui/SectionTag';
import { PrimaryButton } from '../ui/PrimaryButton';
import { scrollToId } from '../../utils/scroll';
import { galleryItems } from '../../data/materialGallery';
export function MaterialGallery() {
  return <section className="bg-bg-secondary py-10 sm:py-14" data-id="element-158" data-mp="qk6ugxpzpm5m">
      <div className="mx-auto max-w-3xl px-4 text-center sm:px-6" data-id="element-159" data-mp="qmt0uu159vm9">
        <SectionTag icon="👀" data-id="element-160" data-mp="14j6ic35ohx0q">Material real</SectionTag>
        <h2 className="mt-5 font-heading text-3xl font-bold uppercase leading-tight text-white sm:text-4xl" data-id="element-161" data-mp="zleeqbvo8mgp">
          Abre el material. Mira cómo se trabaja.
        </h2>
        <p className="mt-4 text-base leading-relaxed text-muted sm:text-lg" data-id="element-162" data-mp="1ecdklf54gwwl">
          Estas son páginas reales de la edición que recibes. Amplíalas para ver cómo se organizan las
          sesiones, cómo se representa cada tarea y qué observar para corregir y ajustar la dificultad.
        </p>
      </div>

      <div className="mx-auto mt-8 max-w-6xl px-4 sm:px-6" data-id="element-163" data-mp="1i9t8h6xdiel7">
        <div className="scrollbar-hide flex gap-4 overflow-x-auto pb-2 sm:gap-5" data-id="element-164" data-mp="1xmrf8f5fuaa2">
          {galleryItems.map((item, i) => <m.figure key={item.caption} initial={{
          opacity: 0,
          y: 14
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: i * 0.06
        }} className="flex w-[240px] flex-shrink-0 flex-col overflow-hidden rounded-2xl border border-white/10 bg-bg-primary sm:w-[280px]" data-id="element-165" data-mp="22mn7xi8oqfab" data-mpi={i}>
              <img src={item.image} alt={item.alt} loading="lazy" decoding="async" className="aspect-[4/5] w-full object-cover" data-id="element-166" data-mp="2lh283b6qgdzq" />
              <figcaption className="flex flex-1 flex-col p-4" data-id="element-167" data-mp="308kxu0pe9mwa">
                <h3 className="font-heading text-sm font-semibold text-white sm:text-base" data-id="element-168" data-mp="30685ctm0fu4z">{item.title}</h3>
                <p className="mt-2 flex-1 text-xs leading-relaxed text-muted sm:text-sm" data-id="element-169" data-mp="347jy3806kvhe">{item.text}</p>
                <p className="mt-3 text-[11px] font-medium uppercase tracking-wide text-lime" data-id="element-170" data-mp="152s82w6jfel5">
                  {item.caption}
                </p>
              </figcaption>
            </m.figure>)}
        </div>
        <p className="mt-3 text-center text-xs text-muted sm:hidden" data-id="element-171" data-mp="196zzj14dr8n2">← Desliza para ver más ejemplos →</p>
      </div>

      <div className="mt-8 flex justify-center px-4" data-id="element-172" data-mp="1nuuteku4jj1q">
        <PrimaryButton onClick={() => scrollToId('oferta-base')} data-id="element-173" data-mp="1nxh06i96xuiw">Ver todo lo que incluye</PrimaryButton>
      </div>
    </section>;
}